import React, { FormEvent, useState } from 'react';
import { ArrowUpIcon } from 'lucide-react';
type ChatMessage = {
  id: number;
  role: 'assistant' | 'user';
  text: string;
};
const starterPrompts = ['What inventory should I send first?', 'How does recovery pricing work?', 'Which channels fit my brand?'];
export function CarliChat() {
  const [messages, setMessages] = useState<ChatMessage[]>([{
    id: 1,
    role: 'assistant',
    text: 'Hi, I’m Carli. Ask me about recovery strategy, inventory, or the best place to start.'
  }]);
  const [draft, setDraft] = useState('');
  const sendMessage = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const question = draft.trim();
    if (!question) return;
    setMessages(currentMessages => [...currentMessages, {
      id: Date.now(),
      role: 'user',
      text: question
    }, {
      id: Date.now() + 1,
      role: 'assistant',
      text: 'Once you connect inventory, I can review sell-through, condition, pricing, and channel fit to recommend the strongest recovery path.'
    }]);
    setDraft('');
  };
  const choosePrompt = (prompt: string) => {
    setDraft(prompt);
  };
  return <aside className="flex min-h-[340px] flex-col bg-[#BB5E40] p-6 text-cream sm:p-8 lg:min-h-0" aria-labelledby="carli-chat-heading" data-id="element-233" data-mp="19xvqalbc23p0">
      <div className="flex items-center gap-2" data-id="element-234" data-mp="14y9b46by2ddk">
        <span className="flex h-7 w-7 items-center justify-center rounded-full bg-cream/15" data-id="element-235" data-mp="1jwbgmm2jd8xg">
          <span aria-hidden="true" className="h-4 w-4 bg-cream" style={{
          WebkitMaskImage: 'url(https://cdn.magicpatterns.com/uploads/uszYpUgDHbmVmVvdioqNYy/Icon_OffWhite.svg)',
          maskImage: 'url(https://cdn.magicpatterns.com/uploads/uszYpUgDHbmVmVvdioqNYy/Icon_OffWhite.svg)',
          WebkitMaskRepeat: 'no-repeat',
          maskRepeat: 'no-repeat',
          WebkitMaskPosition: 'center',
          maskPosition: 'center',
          WebkitMaskSize: 'contain',
          maskSize: 'contain'
        }} data-id="element-236" data-mp="1jtyq3kippq8s" />
        </span>
        <div data-id="element-237" data-mp="zbm0ahq9qr6t">
          <h2 id="carli-chat-heading" className="text-sm font-semibold" data-id="element-238" data-mp="zb3zr8wkpqt3">Ask Carli</h2>
          <p className="text-xs text-cream/65" data-id="element-239" data-mp="14agk9mzz2lsi">Your recovery intelligence layer</p>
        </div>
      </div>

      <div className="mt-5 flex-1 space-y-3" aria-live="polite" data-id="element-240" data-mp="191yl8b1zwmdh">
        {messages.slice(-2).map(message => <div key={message.id} className={`max-w-[92%] rounded-2xl px-3.5 py-3 text-sm leading-relaxed ${message.role === 'assistant' ? 'rounded-tl-sm bg-cream/14 text-cream' : 'ml-auto rounded-tr-sm bg-cream text-ink'}`} data-id="element-241" data-mp="1dzqeb8edmej9">
            {message.text}
          </div>)}
      </div>

      {messages.length === 1 && <div className="mt-4 flex flex-wrap gap-2" aria-label="Suggested questions" data-id="element-242" data-mp="3otmik7kx8gwt">
          {starterPrompts.map(prompt => <button key={prompt} type="button" onClick={() => choosePrompt(prompt)} className="rounded-full border border-cream/25 px-2.5 py-1.5 text-left text-[11px] font-medium text-cream/85 transition-colors hover:bg-cream/12" data-id="element-243" data-mp="3tsfrrnt6dlr6">
              {prompt}
            </button>)}
        </div>}

      <form onSubmit={sendMessage} className="mt-5 flex items-center gap-2 rounded-xl bg-cream p-1.5" data-id="element-244" data-mp="37kjuv5kw1ozt">
        <label htmlFor="carli-message" className="sr-only" data-id="element-245" data-mp="90k0n1u2vldq">Message Carli</label>
        <input id="carli-message" value={draft} onChange={event => setDraft(event.target.value)} placeholder="Ask Carli anything…" className="min-w-0 flex-1 bg-transparent px-2 text-sm text-ink placeholder:text-ink/45 outline-none" data-id="element-246" data-mp="42igedkx1g0o" />
        <button type="submit" disabled={!draft.trim()} className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-forest text-cream transition-colors hover:bg-forest-dark disabled:cursor-not-allowed disabled:opacity-40" aria-label="Send message" data-id="element-247" data-mp="2jufv59atm9e3">
          <ArrowUpIcon className="h-4 w-4" data-id="element-248" data-mp="cbeihyidulh3" />
        </button>
      </form>
    </aside>;
}